'use client'

import { Builder } from '@builder.io/react'

import { ButtonVariants } from '@src/components/Button/Button'

import { SKUSelectorV2 } from './SKUSelectorV2'
import { SKUSelectorV2Defaults } from './SKUSelectorV2.defaults'

Builder.registerComponent(SKUSelectorV2, {
  name: 'SKUSelectorV2',
  inputs: [
    {
      name: 'previewAllItems',
      type: 'boolean',
      defaultValue: SKUSelectorV2Defaults.previewAllItems,
    },
    {
      name: 'style',
      type: 'string',
      enum: ['dropdown', 'radio', 'pill'],
      defaultValue: SKUSelectorV2Defaults.style,
    },
    {
      name: 'pill',
      type: 'object',
      showIf: 'options.get("style") === "pill"',
      defaultValue: SKUSelectorV2Defaults.pill,
      subFields: [
        {
          name: 'options',
          type: 'list',
          subFields: [
            {
              name: 'sku',
              type: 'text',
              localized: true,
            },
            {
              name: 'content',
              type: 'blocks',
              localized: true,
              hideFromUI: true,
            },
          ],
        },
      ],
    },
    {
      name: 'dropdown',
      type: 'object',
      showIf: 'options.get("style") === "dropdown"',
      defaultValue: SKUSelectorV2Defaults.dropdown,
      subFields: [
        {
          name: 'options',
          type: 'list',
          subFields: [
            {
              name: 'sku',
              type: 'text',
              localized: true,
            },
            {
              name: 'content',
              type: 'blocks',
              localized: true,
              hideFromUI: true,
            },
            {
              name: 'contentTop',
              type: 'blocks',
              localized: true,
              hideFromUI: true,
            },
          ],
        },
      ],
    },
    {
      name: 'radio',
      type: 'object',
      showIf: 'options.get("style") === "radio"',
      defaultValue: SKUSelectorV2Defaults.radio,
      subFields: [
        {
          name: 'options',
          type: 'list',
          subFields: [
            {
              name: 'isDropdown',
              type: 'boolean',
              defaultValue: false,
            },
            {
              name: 'sku',
              type: 'text',
              localized: true,
              showIf: 'options.get("isDropdown") !== true',
            },
            {
              name: 'content',
              type: 'blocks',
              localized: true,
              hideFromUI: true,
              defaultValue: SKUSelectorV2Defaults.radio?.options[1].content,
            },
            {
              name: 'dropdownOptions',
              showIf: 'options.get("isDropdown") === true',
              type: 'list',
              defaultValue: SKUSelectorV2Defaults.radio?.options[0].dropdownOptions,
              subFields: [
                {
                  name: 'sku',
                  type: 'text',
                  localized: true,
                },
                {
                  name: 'content',
                  type: 'blocks',
                  localized: true,
                  hideFromUI: true,
                },
                {
                  name: 'contentTop',
                  type: 'blocks',
                  localized: true,
                  hideFromUI: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'addToCartContent',
      type: 'blocks',
      hideFromUI: true,
      defaultValue: SKUSelectorV2Defaults.addToCartContent,
    },
    {
      name: 'addToCartVariant',
      type: 'string',
      enum: ButtonVariants,
      defaultValue: SKUSelectorV2Defaults.addToCartVariant,
      friendlyName: 'CTA Color Variant',
    },
    {
      name: 'redirectUrl',
      type: 'text',
      localized: true,
      defaultValue: SKUSelectorV2Defaults.redirectUrl,
    },
  ],
})
